var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16016 11.7201H4.26562V5.39453H2.16016V11.7201ZM4.40104 3.44531C4.39193 2.82552 3.94531 2.35156 3.22526 2.35156C2.50521 2.35156 2.03125 2.82552 2.03125 3.44531C2.03125 4.04688 2.48698 4.53906 3.19792 4.53906H3.20703C3.94531 4.53906 4.40104 4.04688 4.40104 3.44531ZM7.52995 6.28906V6.31797H7.51172C7.51769 6.30842 7.52376 6.29878 7.52995 6.28906ZM7.52734 6.2875V5.39583H5.42188C5.42188 5.39583 5.44922 5.98828 5.42188 11.7214H7.52734V8.1849C7.52734 8.0026 7.53646 7.8112 7.59115 7.67448C7.74609 7.30078 8.09245 6.90885 8.67578 6.90885C9.43229 6.90885 9.73307 7.48307 9.73307 8.33984V11.7214H11.8385V8.09375C11.8385 6.15234 10.7995 5.25 9.41406 5.25C8.30852 5.25 7.80473 5.85176 7.52734 6.2875ZM14 2.625V11.375C14 12.8242 12.8242 14 11.375 14H2.625C1.17578 14 0 12.8242 0 11.375V2.625C0 1.17578 1.17578 0 2.625 0H11.375C12.8242 0 14 1.17578 14 2.625Z",
    fill: "#8D8B97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.80585968fb16349a7da6c1bbfe52e493.svg";
export { ForwardRef as ReactComponent };